@import "../../global/normalize.css";

/**
 * @prop --ic-z-index-navigation-item: z-index of navigation group item
 */

:host {
  display: block;

  --ic-typography-color: currentcolor;
}

:host(.in-side-menu) {
  border-bottom: var(--ic-border-width) solid
    var(--ic-divider-background-monochrome);
  padding: var(--ic-space-md) 0;
}

:host .navigation-group {
  height: 100%;
  width: fit-content;
  color: var(--ic-brand-text-color);
  display: flex;
  gap: var(--ic-space-xxs);
  align-items: center;
  justify-content: center;
  padding: 0 var(--ic-space-md);
  transition: var(--ic-easing-transition-slow);
  position: relative;
  background: none;
  border: none;
  text-align: left;
  box-sizing: border-box;
}

:host .navigation-group:hover,
:host .navigation-group:active,
:host .selected {
  background-color: var(--ic-architectural-20);
  color: var(--ic-color-text-primary-light);
  outline: none;
  cursor: pointer;
}

:host(.in-side-menu) .navigation-group {
  min-height: 2.5rem;
  width: 100%;
  gap: 1.25rem;
}

:host(.in-side-menu) .navigation-group .ic-typography-label {
  width: 100%;
}

:host(.in-side-menu:not(.ic-navigation-group-expandable)) .navigation-group,
:host(.in-side-menu) .navigation-group-side-menu-collapsed,
:host(.in-side-menu) .navigation-group-side-menu-expanded {
  color: var(--ic-top-navigation-nav-group-link);
  justify-content: flex-start;
  padding: var(--ic-space-xs) var(--ic-space-md);
}

:host(.in-side-menu) .navigation-group-side-menu-expanded {
  margin-bottom: var(--ic-space-xs);
}

:host(.in-side-menu) .navigation-group-side-menu-collapsed::after,
:host(.in-side-menu) .navigation-group-side-menu-expanded::after {
  border-style: solid;
  border-width: 0.125em 0.125em 0 0;
  content: "";
  display: inline-block;
  min-height: 0.45em;
  position: relative;
  top: -0.1em;
  transform: rotate(135deg);
  vertical-align: top;
  min-width: 0.45em;
}

:host(.in-side-menu) .navigation-group-side-menu-expanded::after {
  top: 0.15em;
  transform: rotate(-45deg);
}

:host(:not(.in-side-menu)) .navigation-group:focus {
  box-shadow: var(--ic-border-focus);
  border-radius: var(--ic-border-radius);
  outline: var(--ic-hc-focus-outline);
  z-index: var(--ic-z-index-navigation-item);
  transition: box-shadow var(--ic-easing-transition-fast);
}

:host(.in-side-menu) .navigation-group-side-menu-expanded:hover:not(:focus),
:host(.in-side-menu) .navigation-group-side-menu-collapsed:hover:not(:focus) {
  background-color: var(--ic-top-navigation-nav-group-hover);
  cursor: pointer;
}

:host(.in-side-menu) .navigation-group-side-menu-expanded:active:not(:focus),
:host(.in-side-menu) .navigation-group-side-menu-collapsed:active:not(:focus) {
  background-color: var(--ic-top-navigation-nav-group-pressed);
}

:host(.in-side-menu) .navigation-group-side-menu-expanded:focus,
:host(.in-side-menu) .navigation-group-side-menu-collapsed:focus {
  box-shadow: var(--ic-border-focus-inset);
  border-radius: var(--ic-border-radius-inset);
  outline: var(--ic-hc-focus-outline);
  background: none;
}

:host .navigation-group-dropdown {
  background-color: var(--ic-top-navigation-menu-background);
  border-bottom: var(--ic-space-1px) solid var(--ic-top-navigation-menu-border);
  position: absolute;
  left: 0;
  right: 0;
  padding: var(--ic-space-xs) var(--ic-space-md);
  box-shadow: 0 0.375rem 0.5rem -0.375rem rgba(0 0 0 / 20%);
  z-index: calc(var(--ic-z-index-navigation-item) - 1);
}

:host .navigation-group-dropdown-items-list {
  list-style: none;
  display: flex;
  flex-flow: column wrap;
  align-content: flex-start;
  padding-left: var(--ic-space-md);
  max-height: 16.5rem;
}

:host .chevron-toggle-icon-wrapper {
  display: flex;
  align-items: center;
}

:host .chevron-toggle-icon-wrapper svg {
  transform: rotate(90deg);
  height: var(--ic-space-lg);
  width: var(--ic-space-lg);
}

:host .chevron-toggle-icon-closed svg {
  transform: rotate(-90deg);
}

#nav-group-title {
  text-wrap: nowrap;
}

:host(.in-side-menu) #nav-group-title {
  text-wrap: wrap;
}

:host(.ic-navigation-group-side-nav) #nav-group-title {
  text-wrap: wrap;
}

:host(.ic-navigation-group-expanded) .grouped-links-wrapper {
  height: var(--navigation-child-items-height, auto) !important;
  transition: var(--ic-easing-transition-slow);
  overflow: hidden;
}

:host(.ic-navigation-group-side-nav) .link,
:host(.ic-navigation-group-side-nav) ::slotted(a) {
  height: var(--navigation-child-items-height, auto);
}

:host(.ic-navigation-group-collapsed) .grouped-links-wrapper {
  height: 0;
  transition: var(--ic-easing-transition-slow);
  overflow: hidden;
}

:host(.ic-navigation-group-side-nav) .navigation-group {
  min-height: var(--navigation-group-height);
  height: fit-content;
  min-width: 100%;
  width: var(--navigation-group-width, auto);
  justify-content: var(--navigation-group-justify-content);
  padding: var(--ic-space-md) var(--navigation-group-expand-toggle-padding)
    var(--ic-space-xs) var(--ic-space-md);
}

:host(.ic-navigation-group-side-nav:not(.ic-navigation-group-expandable))
  .navigation-group {
  padding-right: var(--ic-space-md);
}

:host(.ic-navigation-group-side-nav) .navigation-group:hover,
:host(.ic-navigation-group-side-nav) .navigation-group:active,
:host(.ic-navigation-group-side-nav) .selected {
  background-color: var(--navigation-group-hover);
  color: var(--navigation-group-text-hover);
}

:host(.ic-navigation-group-side-nav:not(.ic-navigation-group-expandable))
  .navigation-group:hover,
:host(.ic-navigation-group-side-nav:not(.ic-navigation-group-expandable))
  .navigation-group:active,
:host(.in-side-menu:not(.ic-navigation-group-expandable))
  .navigation-group:hover,
:host(.in-side-menu:not(.ic-navigation-group-expandable))
  .navigation-group:active {
  background: none;
  cursor: auto;
}

:host(.ic-navigation-group-side-nav) .navigation-group:focus {
  box-shadow: var(--ic-border-focus-inset);
  border-radius: var(--ic-border-radius-inset);
  background: none;
}

:host(.ic-navigation-group-side-nav) .ic-typography-caption {
  position: var(--navigation-group-title-position);
  left: var(--navigation-group-title-position-left);
}

@media (prefers-reduced-motion: reduce) {
  :host .navigation-group,
  :host(:not(.in-side-menu)) .navigation-group:focus,
  :host(.ic-navigation-group-expanded) .grouped-links-wrapper,
  :host(.ic-navigation-group-collapsed) .grouped-links-wrapper {
    transition: none;
  }
}
